//props

export type PlanNameType = 'Pro' | 'Business' | 'Enterprise' | 'Free'
export type PaymentPeriodType = 'month' | 'year'

export enum Currency {
	Usd = 'usd',
	Inr = 'inr',
	Eur = 'eur',
}

export interface SubscribePlanDataProps {
	priceId: string
	planName: PlanNameType
	paymentPeriod: PaymentPeriodType
	currency: Currency
	users: number
}

export interface ChangePlanQuotaDataProps {
	users: number
	comment?: string
}

// items
export interface PlanInvoice {
	id: string
	externalId: string
	date: string | Date
	plan: string
	amount: number
	currency: Currency
	status: number
}
export interface PlanPaymentMethod {
	id: string
	name: string
	isDefault: boolean
}

export interface Plan {
	name: PlanNameType
	priceId?: string
	price: number
	currency: Currency
	paymentPeriod: PaymentPeriodType
	paymentMethods: PlanPaymentMethod[]
	dueDate: string | Date
	totalUsers: number
	totalStorage: number
	maxUsers: number
	minUsers?: number
	maxStorage: number
	storagePerUser?: number
	featuresAvailable: number
	featuresEnabled: number
	invoices: PlanInvoice[]
	status: number
	trial?: boolean
}

// responses
export interface GetPlanDataResponse {
	data: Plan
	errors: any[]
	success: boolean
}

export interface CreateBillingLinkDataResponse {
	data: {
		url: string
	}
	errors: any[]
	success: boolean
}

export interface PdfDataResponse {
	data: string | ArrayBuffer // PDF content as string or binary data
	errors: any[]
	success: boolean
}

export interface GetPlanProductDataResponse {
	data: PlanProduct[]
	errors: any[]
	success: boolean
}

export interface PlanProduct {
	id: string
	name: string
	description: null | string
	metadata: Record<string, unknown>
	prices?: Price[]
	unitLabel: null | string
	marketingFeatures?: MarketingFeature[]
}

export interface MarketingFeature {
	name: string
}

export interface Price {
	id: string
	unitAmount: number
	currency: Currency
	recurring: Recurring
}

export interface Recurring {
	interval: PaymentPeriodType
	interval_count: number
	meter: null
	trial_period_days: null
	usage_type: UsageType
}

export enum UsageType {
	Licensed = 'licensed',
}
